import React from "react";
import { LockIcon } from "../assets/lock-icon";
import {
  LockIconWrapper,
  PastClassDetailMaterialBlock,
  PastClassDetailMaterialItem,
  PastClassDetailMaterialTitle,
  PastClassDetailsStudyMaterialCard,
  PastClassDetailsStudyMaterialContainer,
  PastClassDetailStudyMaterialCardIcon,
  PastClassDetailStudyMaterialCardTitle,
  PastClassDetailStudyMaterialDownloadLink,
  PastClassDetailVideoThumbnail,
  PastClassDetailVideoThumbnailIcon,
  PastClassDetailVideoThumbnailWrapper
} from "./past-class-detail-modal.styles";
import { IVideoMaterialBlock } from "./past-class-detail-modal.types";
import { SubscriptionType } from "../../../services/api/sessions/sessionService.types";
import { useTrialActivationModal } from "../trial-activation-modal/use-trial-activation";
import { TrialActivationModal } from "../trial-activation-modal/trial-activation-modal";
import Image from "next/legacy/image";
import DownloadLockIcon from "public/assets/kelas-live/download-lock.svg";
import { Copy } from "components/icons/copy";
import { Play } from "components/icons/play";

const SingleClassMaterialBlock: React.FC<IVideoMaterialBlock> = ({
  setSelectedVideo,
  baseMediaURL,
  currentDownloadingFile,
  downloadStudyMaterial,
  classSession,
  videoMaterials,
  canAccessStudyMaterial,
  subscriptionStatus,
  primaryUser
}) => {
  const { showTrialActivation, setShowTrialActivation } =
    useTrialActivationModal(primaryUser.access_token);
  return (
    <PastClassDetailMaterialBlock>
      {videoMaterials.length > 0 && (
        <PastClassDetailMaterialItem>
          <PastClassDetailMaterialTitle>
            Tonton video materi
          </PastClassDetailMaterialTitle>
          {videoMaterials.map((video, idx) => (
            <PastClassDetailVideoThumbnailWrapper
              key={idx}
              onClick={() => {
                if (
                  subscriptionStatus.subscriptionType === SubscriptionType.FREE
                ) {
                  setShowTrialActivation.on();
                } else {
                  canAccessStudyMaterial && setSelectedVideo(video);
                }
              }}
              canAccessStudyMaterial={canAccessStudyMaterial}
            >
              <PastClassDetailVideoThumbnail
                src={`${baseMediaURL}/${video.thumbnailUrl}`}
                alt={`video material for ${classSession.topic}`}
              />
              <PastClassDetailVideoThumbnailIcon
                canAccessStudyMaterial={canAccessStudyMaterial}
              >
                {canAccessStudyMaterial ||
                subscriptionStatus.subscriptionType ===
                  SubscriptionType.FREE ? (
                  <Play />
                ) : (
                  <LockIconWrapper>
                    <LockIcon width="30" height="30" />
                  </LockIconWrapper>
                )}
              </PastClassDetailVideoThumbnailIcon>
            </PastClassDetailVideoThumbnailWrapper>
          ))}
        </PastClassDetailMaterialItem>
      )}
      {classSession.studyMaterialUrls &&
        classSession.studyMaterialUrls.length > 0 && (
          <PastClassDetailMaterialItem>
            <PastClassDetailMaterialTitle>
              Download materi kelas
            </PastClassDetailMaterialTitle>
            <PastClassDetailsStudyMaterialContainer>
              {classSession.studyMaterialUrls.map((studyMaterial, idx) => (
                <PastClassDetailsStudyMaterialCard key={idx}>
                  <PastClassDetailStudyMaterialCardIcon>
                    <Copy />
                  </PastClassDetailStudyMaterialCardIcon>
                  <PastClassDetailStudyMaterialCardTitle>
                    {studyMaterial.fileName}
                  </PastClassDetailStudyMaterialCardTitle>
                  <PastClassDetailStudyMaterialDownloadLink
                    variant="primary"
                    isLoading={currentDownloadingFile === studyMaterial.url}
                    loadingText="Loading..."
                    onClick={() => {
                      if (
                        subscriptionStatus.subscriptionType ===
                        SubscriptionType.FREE
                      ) {
                        setShowTrialActivation.on();
                      } else {
                        downloadStudyMaterial(
                          `${baseMediaURL}/${studyMaterial.url}`,
                          studyMaterial.fileName
                        );
                      }
                    }}
                    disabled={
                      subscriptionStatus.subscriptionType ===
                      SubscriptionType.FREE
                        ? false
                        : !canAccessStudyMaterial
                    }
                  >
                    {subscriptionStatus.subscriptionType ===
                      SubscriptionType.FREE_AFTER_PAID ||
                    subscriptionStatus.subscriptionType ===
                      SubscriptionType.FREE_AFTER_TRIAL ||
                    subscriptionStatus.subscriptionType ===
                      SubscriptionType.PAUSED ? (
                      <Image src={DownloadLockIcon} alt="Download" />
                    ) : null}
                    Download
                  </PastClassDetailStudyMaterialDownloadLink>
                </PastClassDetailsStudyMaterialCard>
              ))}
            </PastClassDetailsStudyMaterialContainer>
          </PastClassDetailMaterialItem>
        )}

      {showTrialActivation && (
        <TrialActivationModal
          onClose={() => setShowTrialActivation.off()}
          primaryUser={primaryUser}
          subscriptionStatus={subscriptionStatus}
        />
      )}
    </PastClassDetailMaterialBlock>
  );
};

export { SingleClassMaterialBlock };
